import { gql } from '@apollo/client';

export const CREATE_BOOKING = gql`
  mutation CreateBooking($input: BookingInput!) {
    createBooking(input: $input) {
      id
      status
      statutReservation
      travelerCount
      totalPrice
      createdAt
      package {
        id
        title
      }
      formula {
        id
        name
      }
    }
  }
`;

export const CANCEL_BOOKING = gql`
  mutation CancelBookingClient(
    $id: Int!
    $annulationPar: String
    $clientEmail: String
    $agencyId: Int
  ) {
    cancelBooking(
      id: $id
      annulationPar: $annulationPar
      clientEmail: $clientEmail
      agencyId: $agencyId
    ) {
      id
      status
      statutReservation
      statutDisponibilite
      annulationPar
      annuleLe
    }
  }
`;

